export default {
    button_request_permission: 'Permitir',
    default_notification: {
        title: '¡Nueva Notificación!',
        text: 'Ha recibido una nueva notificación, haga clic aquí para ver',
    },
    notification_permissions: {
        allow: {
            title: 'Permitir Notificaciones',
            text: `Algunas funciones del sistema utilizan notificaciones del navegador.\nPermita que el sistema envíe notificaciones.`,
        },
        denied: {
            title: 'Notificaciones Bloqueadas',
            text: 'Hemos identificado que ha denegado el acceso a las notificaciones y es posible que algunas funciones no funcionen.\n'+
                'Permita que el sistema envíe notificaciones haciendo clic en el ícono en el lado izquierdo o derecho de la barra de navegación \n' +
                'donde aparece la dirección https://app.taskier.io en su navegador y recargar la página.',
        },
        noSupport: {
            title: 'Navegador no Compatible',
            text: 'Ese navegador no soporta notificaciones y algunas funcionalidades del sistema no funcionan correctamente',
        },
        braveBlocked: {
            title: 'Navegador Brave',
            text: 'Su navegador probablemente le impide recibir notificaciones automáticas.' +
                '\nPara desbloquear, abra una nueva pestaña, ingrese el enlace "brave://settings/privacy" y habilite la opción "Usar los servicios de Google para recibir mensajes push"',
        },
    },
    service_chat: {
        answer: {
            title: 'Solicitud de Chat',
            text: 'El cliente {{name}} está esperando servicio en el chat',
        },
        accept_transfer: {
            title: 'Solicitud de Transferencia de Chat',
            text: 'El usuario {{agent}} está transfiriendo el chat del cliente {{customer}}',
        },
    },
}
